import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { selectors as userSelectors } from 'ducks/user';
import SubHeader from 'components/general/SubHeader/SubHeader';

const getAlertsQuery = createSelector(
  userSelectors.preferences,
  R.prop('dashboardAlerts'),
);

const UserAlertsSubHeader = connect(state => ({
  title: 'Your latest alerts',
  action: {
    title: 'View all alerts',
    icon: 'bell',
    to: {
      type: 'ALERTS_INDEX',
      query: getAlertsQuery(state),
    },
  },
}))(SubHeader);

export default UserAlertsSubHeader;
